<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div
    class="ui basic segment"
    appMargin="0"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="detailForm">
      <div class="ui one column grid" appMargin marginB="10px">
        <div class="ui column">
          <h2
            class="ui text"
            style="
              font-family: Roboto;
              font-size: 14px;
              font-weight: 700;
              line-height: 19.6px;
              text-align: left;
              color: #505050;
            "
          >
            {{ documentsType.documentTypeName }}
          </h2>
        </div>
      </div>
      <div class="field required" [ngClass]="displayFieldCss('documentName')">
        <label> Document Name</label>
        <input
          formControlName="documentName"
          type="text"
          placeholder="Enter Document Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('documentName')"
          errorMsg="Please enter Total Share Capital"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Close
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!detailForm.valid || pending"
    (click)="submit()"
    autofocus
  >
    Save
  </button>
</div>
